<template>
    <span class="yushu-user-avator" :style="style" style="display: inline-block;">
        <img :src="Utils.getAvator(userId, size)" :style="style">
        <!-- <el-image class="avator" filt="cover" :src="Utils.getAvator(userId, size)" :style="style">
            <div slot="error" class="image-slot">
                <i class="el-icon-user"></i>
            </div>
        </el-image> -->
    </span>
</template>
<script>
export default {
    name: 'YushuUserAvator',
    props: ['uid', 'size'],
    data() {
        return {
            avatorUrl: null,
            userId: '',
            style: {
                width: "32px",
                height: "32px"
            },
        }
    },
    mounted() {
        this.userId = this.uid ? this.uid : this.$store.getters.user.id;
        if (this.size) {
            let p = this.size.split('x');
            this.style = {
                width: p[0] + "px",
                height: p[1] + "px",
            }
        }
    },
    methods: {
    }
}
</script>
<style lang="less" scoped>
.yushu-user-avator {
    width: 100%;
    height: 100%;
    img {
        width: 100%;
        height: 100%;
    }
}
</style>